import React, { useEffect, useRef, useState } from 'react';
import { auth } from '../services/api';
import './Login.css';

// Étape 2 de la connexion (2026-10-10) : après Microsoft, code à 6 chiffres de
// Microsoft Authenticator. Premier passage = QR code à scanner, puis le code
// pour confirmer ; ensuite, le code seul. Le jeton provisoire vaut 5 minutes.
export default function DoubleAuth({ tempToken, configurer, onSuccess, onAnnuler }) {
  const [qr, setQr] = useState(null);
  const [secret, setSecret] = useState('');
  const [voirSecret, setVoirSecret] = useState(false);
  const [code, setCode] = useState('');
  const [erreur, setErreur] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const champ = useRef(null);

  useEffect(() => {
    if (!configurer) { champ.current?.focus(); return; }
    auth.setup2fa(tempToken)
      .then((r) => { setQr(r.data.qrcode_data_url); setSecret(r.data.secret_base32); setTimeout(() => champ.current?.focus(), 50); })
      .catch((e) => setErreur(e.response?.data?.error || 'QR code indisponible — reconnectez-vous'));
  }, [tempToken, configurer]);

  const valider = async (e) => {
    e.preventDefault();
    const c = code.replace(/\s/g, '');
    if (!/^\d{6}$/.test(c)) { setErreur('Le code compte 6 chiffres'); return; }
    setEnvoi(true); setErreur('');
    try {
      const r = await (configurer ? auth.enable2fa : auth.verify2fa)(tempToken, c);
      localStorage.setItem('bi-token', r.data.token);
      onSuccess(r.data.user);
    } catch (err) {
      setErreur(err.response?.data?.error || 'Code incorrect');
      setCode(''); champ.current?.focus();
    } finally { setEnvoi(false); }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-brand">
          <h1 className="login-mark" aria-label="A97 BI">A<span>97</span><span className="login-mark-app">BI</span></h1>
          <span className="login-subtitle">{configurer ? 'Activez la double authentification' : 'Double authentification'}</span>
        </div>

        {erreur && <div className="login-error" role="alert"><span>{erreur}</span></div>}

        {configurer && (
          <div className="da-config">
            <ol className="da-etapes">
              <li>Installez <b>Microsoft Authenticator</b> sur votre téléphone.</li>
              <li>Dans l'application : <b>+</b> ▸ Autre compte ▸ scannez ce QR code.</li>
              <li>Saisissez le code à 6 chiffres affiché.</li>
            </ol>
            <div className="da-qr">{qr ? <img src={qr} alt="QR code à scanner avec Microsoft Authenticator" width="200" height="200" /> : <span className="spinner" />}</div>
            {secret && (
              <p className="da-secret">
                <button type="button" onClick={() => setVoirSecret((v) => !v)}>{voirSecret ? 'Masquer la clé' : 'Impossible de scanner ? Saisir la clé'}</button>
                {voirSecret && <code>{secret.match(/.{1,4}/g).join(' ')}</code>}
              </p>
            )}
          </div>
        )}
        {!configurer && <p className="da-texte">Saisissez le code à 6 chiffres affiché par Microsoft Authenticator pour <b>A97 BI</b>.</p>}

        <form onSubmit={valider} className="da-form">
          <input ref={champ} className="da-code" inputMode="numeric" autoComplete="one-time-code" maxLength={7}
            placeholder="000000" aria-label="Code à 6 chiffres" value={code}
            onChange={(e) => setCode(e.target.value.replace(/[^\d ]/g, ''))} />
          <button type="submit" className="login-ms-button" disabled={envoi || (configurer && !qr)}>
            {envoi ? <><span className="spinner" /> Vérification…</> : configurer ? 'Activer et se connecter' : 'Valider'}
          </button>
        </form>
        <p className="login-legal">
          <button type="button" className="da-lien" onClick={onAnnuler}>Revenir à la connexion</button>
          {!configurer && <> · téléphone perdu : demandez à un administrateur de réinitialiser votre double authentification.</>}
        </p>
      </div>
      <div className="login-bg-overlay" />
    </div>
  );
}
